// extracted by mini-css-extract-plugin
export default {"container":"ooPAs","text":"_44GDM","title":"_0ivfb"};